import React, { Component } from 'react';
import { FontIcon, TextField } from 'react-md';
import '../css/videoAddStyle.css'



export default class VideoAdd extends Component {
  // Start the popover closed
  state = {
    url: '',
    open: false,
  };

  // When the popover is open and users click anywhere on the page,
  // the popover should close
  componentDidMount() {
    document.addEventListener('click', this.closePopover);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closePopover);
  }

  // Note: make sure whenever a click happens within the popover it is not closed
  onPopoverClick = () => {
    this.preventNextClose = true;
  };

  openPopover = () => {
    if (!this.state.open) {
      this.preventNextClose = true;
      this.setState({
        open: true,
      });
    }
  };

  closePopover = () => {
    if (!this.preventNextClose && this.state.open) {
      this.setState({
        open: false,
      });
    }

    this.preventNextClose = false;
  };

  addVideo = () => {
    const { editorState, onChange } = this.props;
    onChange(this.props.modifier(editorState, { src: this.state.url }));
  };

  changeUrl = (evt) => {
    this.setState({ url: evt });
  };

  render() {
        

    return (
      <div className="draftJsToolbar__buttonWrapper__1Dmqh" >

        <FontIcon style={{fontSize:24}} className="draftJsToolbar__button__qi1gf"
        onClick={this.openPopover} >videocam</FontIcon>

        {this.state.open ?
        <div
          style = {{float:"right"}}
          onClick={this.onPopoverClick}
        >
          <TextField
            placeholder="Paste the video url …"
            className="border-textfield"
            onChange={this.changeUrl}
            value={this.state.url}
          />
          <button
            style = {{hieght:"34px"}}
            type="button"
            onClick={this.addVideo}
          >
            Add
          </button>
           <div  style = {{fontSize:"0.84em "}} className='image-resize-warning'>
            <a rel="noopener noreferrer"  target="_blank" href="https://www.youtube.com/watch?v=jXwQY2mosdE"> Click Here</a> to learn how to add video
            <p style={{marginTop: "5px"}}>Note: Set the video visibility to public on YouTube to remove recommendations at the end of the video.</p>
            </div>
        </div>
        : ""
      }
      </div>
    );
  }
}
